import JSON5 from 'process-js-objects'
import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin'
import { dispatchCustomEventGlobally, initI18n } from 'www/utils'
import ReviewPowerInfo from 'www/vue_components/common/ReviewPowerInfo/ReviewPowerInfo.vue'

const el = document.querySelector('.vue-review-power-info-mount')

const mountReviewPowerInfo = async () => {
  if (el) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/ReviewPowerInfo' })

    Vue.use(I18NextVue, { i18next })

    new Vue({
      vuetify,
      el,
      render: h => h(ReviewPowerInfo),
    })
  }
}

mountReviewPowerInfo()

function dispatchReviewPowerInfoOpen(event: MouseEvent) {
  if (!(event.target instanceof HTMLElement)) {
    return
  }

  const element = event.target.closest('[data-review-power-info-open]')

  if (!element) {
    return
  }

  event.preventDefault()

  const data = JSON5.parse(element.getAttribute('data-review-power-info-open') ?? '{}')

  dispatchCustomEventGlobally('review-power-info:open', data)
}

window.addEventListener('click', dispatchReviewPowerInfoOpen)
